import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectMarketerSubset: "userSelectMarketerSubset [Action]",
  userSelectMarketerSubsetLoading: "userSelectMarketerSubsetLoading [Action]",
  userSelectMarketerSubsetAsync: "userSelectMarketerSubsetAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_marketer_subset_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectMarketerSubset:
      return {
        ...state,
        data: payload?.data?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectMarketerSubsetLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectMarketerSubsetLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_marketers_subset",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectMarketerSubset,
      payload: res?.data?.response,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectMarketerSubsetLoading,
      payload: false,
    });
  }
}

export function* userSelectMarketerSubset() {
  yield takeLatest(actionTypes.userSelectMarketerSubsetAsync, handleWorker);
}
